import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const FloatingButton = () => {
  const [showButton, setShowButton] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 200) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div
      className={`bg-[#1a9588] hover:bg-[#28b5a6] hover:shadow-xl rounded-full fixed bottom-4 right-4 sm:bottom-5 sm:right-5 z-[1030] ${
        showButton ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
      } transition-all duration-500 ease-out`}
    >
      <button
        className="flex items-center justify-center w-10 h-10 sm:w-11 sm:h-11 md:w-12 md:h-12 rounded-full bg-[#1a9588] hover:bg-[#28b5a6] hover:shadow-xl text-white shadow-lg transform transition-all duration-300 ease-in-out"
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <FaArrowUp className="text-base sm:text-lg text-white" />
      </button>
    </div>
  );
};

export default FloatingButton;